import api from './api';
import type { DriverEndpointsResponse } from '../types/driverEndpoints';

export async function fetchDriverEndpoints(): Promise<DriverEndpointsResponse> {
  const response = await api.get<DriverEndpointsResponse>('/otr-by-location');
  return response.data;
}
